import template   from './my-toolbox.html'
import controller from './my-toolbox.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-toolbox/my-toolbox.component.js